import { colors } from 'theme'

export const defaultThemeStyles = {
    background: colors.darkCloud,
    timelineBackground: 'rgba(0, 0, 0, 0.25)',
    timeline: colors.white,
}
